/**
 * @author gyb(mocheer)
 * @since 2017.7.10
 */
/**
 * 点在多边形
 */
export var pointInPolygon = (p, arr) => {
  let nCross = 0;
  if (arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      let p0 = p,
        p1 = arr[i],
        p2 = arr[(i + 1) % arr.length];
      // 求解 y=p.y 与 p1p2 的交点
      if (p1.y == p2.y || p0.y < (p1.y <= p2.y ? p1.y : p2.y) || p0.y >= (p1.y >= p2.y ? p1.y : p2.y)) // p1p2 与 y=p0.y平行,交点在p1p2延长线上,交点在p1p2延长线上 
        continue;
      if ((p0.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x > p0.x) nCross++; //交点的X坐标大于p0的x坐标，只统计单边交点 			
    }
  }
  // 单边交点为偶数，点在多边形之外 --- 
  return (nCross % 2 == 1);
}
/**
* 
* @param s start point
* @param p end point
*/
export var distance = (s, p) => Math.sqrt((p[0] - s[0]) * (p[0] - s[0]) + ((p[1] - s[1]) * (p[1] - s[1])))
/**
 * 
 * @param p 
 * @param angle 
 */
export var toRotate = (p, angle) => {
  angle = Math.atan2(p.y, p.x) + angle
  let r = Math.sqrt(p.x * p.x + p.y * p.y)//半径
  return {
    x: Math.cos(angle) * r,
    y: Math.sin(angle) * r
  }
}


// WEBPACK FOOTER //
// ./src/utils/geoUtils.js